/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, Dispatch } from "react";
import "./open-auction.styles.scss";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import dayjs from "dayjs";

import {
  CloseCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeFilled,
  SyncOutlined,
} from "@ant-design/icons";

import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";

import { Link, useHistory, useLocation } from "react-router-dom";

import Timer from "../../components/timer/timer.component";

import {
  selectBranches,
  selectCrops,
  selectSelectedCrop,
  // selectselectedBranch,
  selectCurrentPage,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
// import { setBranch } from "../../redux/common/common.actions";

import {
  getOpenAuction,
  cancelAuction,
  postBulkApprove,
} from "../../services/auction-services";
import { getRebateMatrixService } from "../../services/common-services";

import {
  Table,
  message,
  Modal,
  Button,
  Checkbox,
  Radio,
  Flex,
  Space,
  Input,
  Tag,
} from "antd";

import { FeatureCodes, dataConstants } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import Axios from "axios";
import duration from "dayjs/plugin/duration";
import {
  setSaudaDetails,
  setSaudaScreen,
  setSelectedCrop,
} from "../../redux/common/common.actions";
dayjs.extend(duration);

const FileDownLoad = require("js-file-download");

const { confirm } = Modal;

const OpenAuction: React.FC = (props: any) => {
  const {
    branches,
    selectedCrop,
    user,
    crops,
    globalSocketData,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setBranch,
    setSaudaDetails,
    setSaudaScreen,
    // auth
  } = props;
  const dispatch = useDispatch();
  const [openData, setOpenData] = useState<any>([]);
  const [slotTime, setSlotTime] = useState<Array<any>>([]);
  const [SelectSlot, setSelectedSlot] = useState<any>();
  // const [bufferTime, setBufferTime] = useState<string>();
  const [filterData, setFilter] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [isProgressClicked, setisProgressClicked] = useState(false);
  const [downloaddata, setdownloaddata] = useState<any>();
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [tableData, setTableData] = useState<Array<any>>();
  const [bagFilter, setBagFilter] = useState<Array<any>>();
  const location = useLocation();
  let openAuctionsIntervalID = useRef<NodeJS.Timeout>();
  const history = useHistory();

  const rebateColumns = [
    {
      title: "Head",
      dataIndex: "head",
      key: "head",
      render(_: any, row: any) {
        return {
          children: row.head,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Slab",
      dataIndex: "slab",
      key: "slab",
    },
    {
      title: "Rebate %",
      dataIndex: "rate_display",
      key: "rate_display",
    },
  ];

  const columns = [
    {
      title: "ID",
      sorter: (a, b) => a.id - b.id,
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Hub",
      sorter: (a, b) => a.hub.localeCompare(b.hub),
      dataIndex: "hub",
      key: "hub",
    },
    {
      title: "Division",
      sorter: (a, b) => a.division - b.division,
      dataIndex: "division",
      key: "division",
      render: (value: number) => {
        return <div>{value === 1 ? "ABD" : value === 2 ? "FBD" : "NCDEX"}</div>;
      },
      // align: "center",
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim",
      render: (value: number) => {
        return (
          <div className="claim-container">
            {value === 1 ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      dataIndex: "variety",
      key: "variety",
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "maxPrice",
      key: "maxPrice",
    },
    {
      title: `Qty Reqd (${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "qtyReqd",
      key: "qtyReqd",
    },
    {
      title: "No of Bids",
      sorter: (a, b) => a.noOfBids - b.noOfBids,
      filters: bagFilter,
      onFilter: (value, record) => record.noOfBids.toString().includes(value),
      dataIndex: "noOfBids",
      key: "noOfBids",
    },
    {
      title: `Total Bid Qty (${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      sorter: (a, b) => a.totalBidQty - b.totalBidQty,
      dataIndex: "totalBidQty",
      key: "totalBidQty",
    },
    {
      title: `Min Bid Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "minBid",
      key: "minBid",
    },
    {
      title: `Max Bid Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "maxBid",
      key: "maxBid",
    },

    {
      title: "Sauda Type",
      dataIndex: "saudaType",
      key: "saudaType",
      render: (value: number) => {
        return <div>{value === 1 ? "Net basis" : "Gross basis"}</div>;
      },
    },
    {
      title: "Role",
      dataIndex: "roleType",
      key: "Role",
      render: (value: number) => {
        return (
          <div style={{ whiteSpace: "break-spaces" }}>
            {value === 1
              ? "Broker/ Trader"
              : value === 2
              ? "FPO"
              : value === 3
              ? "Broker/Trader & FPO"
              : "Not Selected"}
          </div>
        );
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return <div>{value == 2 || value == 3 ? "Y" : "N"}</div>;
      },
    },
    {
      title: "Rebate Name",
      dataIndex: "rebateName",
      key: "rebateName",
      render: (value: number, row: any) => {
        return (
          <div className={"rebate-info"} style={{ whiteSpace: "break-spaces" }}>
            {value}
            {value && (
              <span
                className="info"
                onClick={() => {
                  getRebateMatrix(row.rebateId, selectedBranch);
                }}
              >
                ?
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Sauda Status",
      dataIndex: "saudaStatus",
      key: "saudaStatus",
      render: (value: number, rowData: any) => {
        return (
          <Tag
            color={
              value === 1 && rowData.auto_approval !== 1
                ? "success"
                : value === 2
                ? "error"
                : value === -1
                ? "warning"
                : "geekblue"
            }
            key={
              value === 1 && rowData.auto_approval !== 1
                ? "Accepted"
                : value === 2
                ? "Rejected"
                : value === -1
                ? "Approval Pending"
                : "Not Processed"
            }
          >
            {value === 1 && rowData.auto_approval !== 1
              ? "Accepted"
              : value === 2
              ? "Rejected"
              : value === -1
              ? "Approval Pending"
              : "Not Processed"}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (value: boolean, rowData: any) => {
        const data = {
          ...rowData,
          slotEndTime: rowData.endTime,
          archives: false,
          branch_id: selectedBranch,
          isBm: user.role_name === "Branch Manager",
          crop_id: selectedCrop,
        };
        return (
          <>
            <span
              className={`cancel-container ${
                rowData.saudaStatus !== null ||
                ((!canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)) &&
                  "disable")
              }`}
              onClick={() => showPromiseConfirm(rowData.key)}
            >
              <CloseCircleOutlined />
            </span>
            <span
              className={`edit-container ${
                (!canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)) &&
                "disabled"
              }`}
              onClick={() => {
                setSaudaDetails(data);
                setSaudaScreen(true);
                history.push("/TN/viewauction/active/saudadetails", {
                  datas: data,
                });
              }}
            >
              <EyeFilled />
            </span>
          </>
        );
      },
    },
    // {
    //   title: "",
    //   dataIndex: "sauda",
    //   key: "sauda",
    //   render: (value: number, rowData: any) => {
    //     const data = {
    //       ...rowData,
    //       slotEndTime: rowData.endTime,
    //       archives: false,
    //     };

    //     return (
    //       <Link
    //         to={{
    //           pathname: `/sauda`,
    //           state: {
    //             datas: {
    //               ...data,
    //               archives: false,
    //               branch_id: selectedBranch,
    //               crop_id: selectedCrop,
    //             },
    //           },
    //         }}
    //       >
    //         {rowData.saudaStatus === null &&
    //         canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
    //           ? "Enter Sauda"
    //           : "View Sauda"}
    //       </Link>
    //     );
    //   },
    // },
    {
      title: (
        <div
          style={{
            fontSize: "8px",
            color: "white",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            paddingRight: "13px",
            marginRight: "10px",
          }}
        >
          {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
            canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
            <Checkbox
              style={{ margin: "auto" }}
              checked={selectedData && selectedData.length > 0}
              disabled={
                canUserAccess(user, FeatureCodes.SAUDA_PROCESS) ? false : true
              }
              onChange={(e) => {
                const modifiedData =
                  openData && openData.length
                    ? openData
                        .map((item: any) => {
                          if (
                            dayjs(item.endTime, "HH:mm:ss").isBefore(dayjs()) &&
                            item.noOfBids !== 0 &&
                            item.saudaStatus === null &&
                            (!filterData ||
                              filterData.length === 0 ||
                              filterData.includes(item.noOfBids.toString()))
                          ) {
                            return item.id;
                          }
                        })
                        .filter((item) => item !== undefined)
                    : [];
                if (e.target.checked === true) {
                  if (modifiedData.length > 0) {
                    setSelectedData(modifiedData);
                  } else {
                    message.error(
                      "Sauda can only be Approved during Auction Buffer Time..!"
                    );
                    return false;
                  }
                } else {
                  setSelectedData([]);
                }
              }}
            />
          )}
        </div>
      ),
      key: "action",
      dataIndex: "action",
      render: (value: number, row: any) => {
        return (
          <div className="approval-table-checkbox">
            {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
              canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
              <Checkbox
                checked={
                  Array.isArray(selectedData) && selectedData.includes(row.id)
                }
                disabled={
                  canUserAccess(user, FeatureCodes.SAUDA_PROCESS) &&
                  row.saudaStatus === null
                    ? false
                    : true
                }
                onChange={(e) => {
                  if (dayjs(row.endTime, "HH:mm:ss").isAfter(dayjs())) {
                    message.error(
                      "Cannot approve sauda during auction time..!"
                    );
                  } else if (row.noOfBids === 0) {
                    message.error(
                      "Cannot approve this sauda, since there are no bids!"
                    );
                  } else {
                    if (e.target.checked === true) {
                      setSelectedData([...selectedData, row.id]);
                    } else {
                      const temp = selectedData.filter(
                        (item) => item !== row.id
                      );
                      setSelectedData(temp);
                    }
                  }
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  const getRebateMatrix = async (
    rebateId: string,
    branchId: number | undefined
  ) => {
    const params = {
      rebate_id: rebateId,
      branch_id: branchId,
      crop_id: selectedCrop,
    };
    try {
      const response = await getRebateMatrixService(params);
      if (response.data.status) {
        setTableData(response.data.data);
        setModalVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // if (currentpage == "3" && viewAuctionPage === "32" && globalSocketData) {
    if (
      location.pathname.endsWith("/TN/viewauction/active") &&
      globalSocketData
    ) {
      openAuctionsIntervalID.current &&
        clearInterval(openAuctionsIntervalID.current);
      openAuctionsDataSocketEmition();
      openAuctionsIntervalID.current = setInterval(() => {
        openAuctionsDataSocketEmition();
      }, 10000);
    }
    return () => {
      openAuctionsIntervalID.current &&
        clearInterval(openAuctionsIntervalID.current);
    };
  }, [
    currentpage,
    viewAuctionPage,
    globalSocketData,
    selectedBranch,
    selectedCrop,
  ]);

  /**
   *
   * @function
   * @description Establish socket.io connection for getting auction cards data.
   * @memberof App.MainLayout
   */
  const openAuctionsDataSocketEmition = () => {
    if (globalSocketData) {
      globalSocketData.emit("tm_active_auction_event", {
        crop_id: selectedCrop,
        branch_id: selectedBranch,
      });
      globalSocketData.on("tm_active_auctions", (data: any) => {
        const modifiedData = data.map((item: any) => {
          return {
            key: item.auction_id,
            id: item.auction_id,
            hub: item.hub_name,
            // hubId:item.hub_id,
            hubId: item.hub_id,
            division: item.division,
            claim: item.claim_type,
            variety: item.variety_name,
            varietyId: item.variety_id,
            maxPrice: item.max_price,
            qtyReqd: item.qty_rqd,
            noOfBids: item.no_of_bids === null ? 0 : item.no_of_bids,
            totalBidQty: item.total_bid_qty === null ? 0 : item.total_bid_qty,
            minBid: item.min_bid_price === null ? 0 : item.min_bid_price,
            maxBid: item.max_bid_price === null ? 0 : item.max_bid_price,
            saudaType: item.saudha_type,
            roleType: item.role_mapping,
            saudaStatus: item.auto_approval === 1 ? null : item.saudha_status,
            branchId: selectedBranch,
            rebateName: item.rebate_name,
            rebateId: item.rebate_id,
            bufferTime: item.buffer_time,
            startTime: item.start_time,
            endTime: item.end_time,
            auction_type: item.auction_type,
          };
        });
        let uniqueFilterData: any = [];
        modifiedData.map((mainItem: any) =>
          uniqueFilterData.filter(
            (item) => item["noOfBids"] === mainItem["noOfBids"]
          ).length > 0
            ? null
            : uniqueFilterData.push(mainItem)
        );

        uniqueFilterData = uniqueFilterData
          .map((item) => {
            return {
              text: item["noOfBids"],
              value: item["noOfBids"],
            };
          })
          .sort((a, b) => a.text - b.text);
        setBagFilter(uniqueFilterData);
        setOpenData(modifiedData);
        setIsLoading(false);
      });
    }
  };
  useEffect(() => {
    const sloData = openData
      .filter(
        (obj, index, self) =>
          index ===
          self.findIndex(
            (o) => o.startTime === obj.startTime && o.endTime === obj.endTime
          )
      )
      .map((item) => {
        return {
          bufferTime: item.bufferTime,
          startTime: item.startTime,
          endTime: item.endTime,
        };
      });
    if (JSON.stringify(sloData) !== JSON.stringify(slotTime)) {
      setSlotTime(sloData);
      setSelectedSlot(sloData[0]);
    }
  }, [openData]);
  const fileDownload = async () => {
    setIsSpinnerOnProgress(true);
    const body = {
      branch_id: selectedBranch,
      crop_id: selectedCrop,
    };
    if (process.env.REACT_APP_ENV !== "production") {
      message.success(
        "Mail will send to your official email ID with the report."
      );
      setIsSpinnerOnProgress(false);
      return false;
    }
    Axios({
      url: dataConstants.activeAuctionsExportUrl,
      method: "POST",
      data: body,
      responseType: "blob",
      onDownloadProgress: (progressEvent: any) => {
        let progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setdownloaddata(progress);
      },
    })
      .then((response: any) => {
        FileDownLoad(
          response.data,
          `BufferTime_Auction_Report_${new Date().toLocaleDateString()}.xlsx`
        );
        message.success("File has been downloaded successfully!");
        setIsSpinnerOnProgress(false);
        setTimeout(
          function () {
            setisProgressClicked(false);
          }.bind(this),
          5000
        );
      })
      .catch((err: any) => {
        message.error("File cannot be downloaded");
        setIsSpinnerOnProgress(false);
        setisProgressClicked(false);
      });
  };
  const cancelAuctionFn = async (auctionId: number) => {
    const dataToSend = {
      auction_id_list: [auctionId],
    };
    try {
      const response = await cancelAuction(dataToSend);
      if (response.data.status) {
        message.success("Auction cancelled successfully...!");
        openAuctionsDataSocketEmition();
      } else message.warning("Cannot cancel auction...!");
    } catch (error) {
      console.log(error);
    }
  };

  function showPromiseConfirm(auctionId: number) {
    confirm({
      title: "Cancel Auction",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to cancel the auction ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        cancelAuctionFn(auctionId);
      },
      onCancel() {},
    });
  }

  const createNewArr = (data: any) => {
    if (data)
      return data
        .reduce((result: any, item: any) => {
          //First, take the name field as a new array result
          if (result.indexOf(item.head) < 0) {
            result.push(item.head);
          }
          return result;
        }, [])
        .reduce((result: any, head: any) => {
          //Take the data with the same name as a new array, and add a new field * * rowSpan inside it**
          const children = data.filter((item: any) => item.head === head);
          result = result.concat(
            children.map((item: any, index: any) => ({
              ...item,
              rowSpan: index === 0 ? children.length : 0, //Add the first row of data to the rowSpan field
            }))
          );
          return result;
        }, []);
  };
  const handleChange = (pagination, filters, sorter) => {
    setFilter(filters[7]);
  };
  const onBulkApprove = async (dataToPut: any) => {
    setIsLoading(true);
    dataToPut = dataToPut
      .map((element: any) => {
        if (selectedData.includes(element.id)) return element;
        else return undefined;
      })
      .filter((item: any) => item !== undefined);
    const list = dataToPut.map((eachRow: any) => {
      return eachRow.id;
    });
    if (list !== undefined && list !== null && list !== "" && list.length > 0) {
      const reqBody = {
        auction_ids: list,
      };
      try {
        const response = await postBulkApprove(reqBody);
        if (response.data.status) {
          message.success(response.data.message);
          setSelectedData([]);
          openAuctionsDataSocketEmition();
        } else {
          message.warning("Cannot approve auction...!");
        }
      } catch (error: any) {
        message.warning("Cannot approve auction...!");
      }
    }
    setIsLoading(false);
  };
  return (
    <div className="open-auction">
      <Modal
        className="rebate-modal"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={false}
      >
        <div className="rebate-header">Rebate Matrix</div>
        <div className="rebate-container">
          <Table
            columns={rebateColumns}
            // dataSource={tableData}
            dataSource={createNewArr(tableData)}
            pagination={false}
            scroll={{ y: window.innerHeight - 165 }}
            tableLayout="auto"
            size="small"
          />
        </div>
      </Modal>
      <div className="label noteText">
        <b>
          NOTE: Bulk Approval for auctions requires at least one bid and can
          only be processed during buffer time.
        </b>
      </div>
      <Flex justify="space-between">
        <Space>
          {/* <Input.Search style={{ width: "15em" }} variant="outlined" /> */}
          <CustomFilter
            type="single-select"
            value={selectedBranch}
            onChange={(value: any) => setBranch(value)}
            options={branches}
            placeholder="Select Branch"
            head="ITC Branch Office"
            returnId
          />
          <CustomFilter
            type="single-select"
            value={selectedCrop}
            onChange={(value: any) => dispatch(setSelectedCrop(value))}
            options={crops}
            placeholder="Select Crop"
            head="Crops"
            returnId
          />
        </Space>
        {/* <div className="selected-wheat">
          <span className="selected-wheat-label">Selected Crop</span> <br />
          <span className="selected-wheat-value">
            <b>
              {crops &&
                crops.length &&
                crops.find(
                  (item: { id: number; name: string }) =>
                    item.id == selectedCrop
                ).name}
            </b>
          </span>
        </div> */}
        <Space>
          {openData.length > 0 && (
            <div className="download-button-container">
              {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) &&
                user.role_name !== "Branch Manager" && (
                  <Button
                    className={
                      canUserAccess(user, FeatureCodes.SAUDA_PROCESS)
                        ? "submit-btn"
                        : "submit-btn disabled"
                    }
                    onClick={() => {
                      onBulkApprove(openData);
                    }}
                    size="middle"
                    disabled={canUserAccess(
                      user,
                      FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                    )}
                    loading={isLoading}
                  >
                    Approve
                  </Button>
                )}
              {SelectSlot &&
                !dayjs(SelectSlot.endTime, "HH:mm:ss").isAfter(dayjs()) && (
                  <Button
                    onClick={() => {
                      setdownloaddata(0);
                      setisProgressClicked(true);
                      fileDownload();
                    }}
                    // type="default"
                    // shape="round"
                    size="middle"
                    // className="download-btn-styles"
                    disabled={canUserAccess(
                      user,
                      FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                    )}
                    loading={isProgressClicked}
                  >
                    Download
                  </Button>
                )}
            </div>
          )}
          <Button
            className="refresh"
            size="middle"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() => openAuctionsDataSocketEmition()}
          >
            Refresh
          </Button>
        </Space>
      </Flex>

      {openData.length > 0 && slotTime && SelectSlot !== undefined && (
        <div className="time-data-container">
          <div>
            Slot timings:{" "}
            {slotTime && SelectSlot && (
              <Radio.Group
                defaultValue={slotTime[0]}
                size="small"
                style={{ backgroundColor: "#E6F7FF" }}
                onChange={(e) => setSelectedSlot(e.target.value)}
              >
                {slotTime.map((item, index) => (
                  <Radio.Button key={index} value={item}>
                    {dayjs(item.startTime, "HH:mm:ss").format("hh:mm A")} -{" "}
                    {dayjs(item.endTime, "HH:mm:ss").format("hh:mm A")}
                  </Radio.Button>
                ))}
              </Radio.Group>
            )}
          </div>
          {dayjs(SelectSlot?.endTime, "HH:mm:ss").isAfter(dayjs()) ? (
            <Timer
              time={
                SelectSlot !== undefined
                  ? SelectSlot.endTime
                  : dayjs().format("HH:mm:ss")
              }
            />
          ) : (
            <Timer
              time={dayjs(SelectSlot.endTime, "HH:mm:ss")
                .add(
                  dayjs(SelectSlot.bufferTime, "HH:mm").diff(
                    dayjs("00:00", "HH:mm")
                  ),
                  "milliseconds"
                )
                .format("HH:mm:ss")}
              buffer
            />
          )}
        </div>
      )}
      <div className="open-table-container" style={{ paddingTop: 10 }}>
        <Table
          columns={columns}
          onChange={handleChange}
          dataSource={openData.filter((item) =>
            SelectSlot
              ? item.startTime === SelectSlot.startTime &&
                item.endTime === SelectSlot.endTime
              : item
          )}
          // pagination={false}
          loading={isLoading}
          // scroll={{ x: "max-content" }}
          size="small"
          // tableLayout="auto"
        />
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  selectedCrop: selectSelectedCrop,
  crops: selectCrops,
  user: selectUserData,
  auth: selectAuthData,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setSaudaScreen: (status: boolean) => dispatch(setSaudaScreen(status)),
    setSaudaDetails: (details: any) => dispatch(setSaudaDetails(details)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OpenAuction);
